import { AppBar, Button, Toolbar } from "@material-ui/core";
import { styled } from "@material-ui/styles";
import PropTypes from "prop-types";
import { useApplicationDetails } from "../../hooks/useApplicationDetails";
import { useAuthentication } from "../../hooks/useAuthentication";
import Logo from "./Logo";

const StyledAppBar = styled(({ backgroundColor, menuItemColor, ...rest }) => <AppBar {...rest} />)({
    backgroundColor: (props) => props.backgroundColor,
    display: "flex",
    "& .MuiButton-label": {
        color: (props) => props.menuItemColor,
        textTransform: "capitalize",
        whiteSpace: "nowrap",
    },
});

export const NavBarPresenter = (props) => (
    <StyledAppBar position="static" backgroundColor={props.backgroundColor} menuItemColor={props.menuItemColor}>
        <Toolbar>
            <Logo
                imageUrl={props.imageUrl}
                url={props.url}
                defaultToAvenirHealth={props.defaultToAvenirHealth ?? true}
            />

            <div style={{ flexGrow: 1 }}></div>

            {props.signedIn && (
                <Button color="inherit" onClick={props.onSignOut}>
                    Sign out
                </Button>
            )}
        </Toolbar>
    </StyledAppBar>
);

NavBarPresenter.propTypes = {
    backgroundColor: PropTypes.string,
    menuItemColor: PropTypes.string,
    imageUrl: PropTypes.string,
    url: PropTypes.string,
};

const NavBar = (props) => {
    const authentication = useAuthentication();

    const applicationDetails = useApplicationDetails();

    return (
        <NavBarPresenter
            {...props}
            signedIn={Boolean(authentication.user)}
            backgroundColor={applicationDetails.customization.colors.background}
            menuItemColor={applicationDetails.customization.colors.link}
            imageUrl={applicationDetails.customization.logoUrl}
            url={applicationDetails.proxiedApplicationUrl}
            defaultToAvenirHealth={applicationDetails.loaded}
            onSignOut={authentication.signOut}
        />
    );
};

export default NavBar;
